import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MODAL_STYLES } from '../../utils/modalStyles';

/**
 * Standardized close button for modals
 * Consistent positioning and styling across all modals
 */
const ModalCloseButton = ({ onClick, sx, ...props }) => {
  return (
    <IconButton
      aria-label="close"
      onClick={onClick}
      sx={(theme) => ({
        ...MODAL_STYLES.closeButton(theme),
        ...sx
      })}
      {...props}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default ModalCloseButton;